export class CartOpen {
    public constructor (
        public creation_date?: string,
        public order_date?: string,
    ){}
}